import { render, staticRenderFns } from "./UserPasswordDialog.vue?vue&type=template&id=536f68fa&"
import script from "./UserPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserPasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports